export default __webpack_public_path__ + "static/media/ISEO_CLASS-10_SYLLABUS_2025-26.0259c490.pdf";